import { BrowserProtocol, queryMiddleware } from 'farce';
import { createFarceRouter, createRender } from 'found';
import { Resolver } from 'found-relay';

// Polyfill
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/promise';
import 'core-js/es6/object';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { Environment, RecordSource, Store, Network } from 'relay-runtime';
import routes from './routes/Route';
import './assets/semantic/semantic.css';

const rootNode = document.getElementById('app');

function fetchQuery(operation, variables) {
  return fetch('/queries', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      // Add authentication and other headers here
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      query: operation.text, // GraphQL text from input
      variables
    })
  })
    .then(response => response.json())
    .then(json => {
      if (
        operation.operationKind === 'mutation' &&
        Array.isArray(json.errors)
      ) {
        return Promise.reject(json.errors);
      }
      return json;
    });
}

const network = Network.create(fetchQuery);
const source = new RecordSource();
const store = new Store(source);

const environment = new Environment({
  network,
  store
});

const Router = createFarceRouter({
  historyProtocol: new BrowserProtocol(),
  historyMiddlewares: [queryMiddleware],
  routeConfig: routes,
  render: createRender({})
});

ReactDOM.render(<Router resolver={new Resolver(environment)} />, rootNode);



// WEBPACK FOOTER //
// ./webpack/index.js